(function () {
  'use strict';

  var DEFER_SCRIPT = [
    'static.klaviyo.com',
    'static-tracking.klaviyo.com',
    'a.klaviyo.com',
    'cdn.judge.me',
    'cdnwidget.judge.me',
    'judgeme',
    'judgeme-538',
    'mp-instagram-feed',
    'mp-instagram',
    'dealeasy',
    'restockrooster',
    'mws_fees',
    '/extensions/',
    'shopifycloud/checkout',
    'shopify-perf-kit'
  ];

  var DEFER_STYLE = [
    'widget_v3',
    'widget_form.css',
    'mp-instagram',
    'judgeme',
    'judgeme-538',
    'carousels.css',
    'testimonials_carousel',
    'back-in-stock'
  ];

  var COLLECTION_LAZY_SCRIPT = ['facets.js', 'show-more.js', 'compare.js', 'quick-view.js'];

  var deferredBuckets = {
    general: [],
    dealeasy: [],
    restock: [],
    collectionFacets: [],
    postPaint: [],
    indexApps: []
  };
  var blockedScripts = [];
  var bucketActivated = {
    general: false,
    dealeasy: false,
    restock: false,
    collectionFacets: false,
    postPaint: false,
    indexApps: false
  };
  var restockActivateTimer = null;
  var dealEasyActivateTimer = null;
  var postPaintScheduled = false;

  var activated = false;
  var config = window.SNR_PERF || {};
  var pageType = config.pageType || '';
  var isIndex = config.isIndex || pageType === 'index';
  var isProduct = config.isProduct || pageType === 'product';
  var isCollection = config.isCollection || pageType === 'collection';
  var isBlog = config.isBlog || pageType === 'blog';
  var isTestimonialsPage = config.isTestimonialsPage || false;
  var isContactPage = config.isContactPage || false;
  var needsRestock = config.needsRestock === true;
  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  var indexMobileStrict = isIndex && isMobile;
  var collectionMobileStrict = isCollection && isMobile;
  var productMobileStrict = isProduct && isMobile;
  var mobileStrictDefer = indexMobileStrict || collectionMobileStrict || productMobileStrict;
  var indexAppDefer = isIndex;
  var interactionOnly =
    indexAppDefer || (isMobile && (isCollection || isBlog || isProduct));
  var dealEasyLazyProduct = isProduct;
  var productDesktopStrict = isProduct && !isMobile;
  var strictDefer = mobileStrictDefer || productDesktopStrict;
  var collectionDrawerMode =
    isCollection && window.matchMedia('(max-width: 1279px)').matches;

  function isCollectionLazyScript(url) {
    return url && matches(url, COLLECTION_LAZY_SCRIPT);
  }

  function isFraudGuardAsset(url) {
    return url && url.indexOf('fraud-guard') !== -1;
  }

  function isBlockedProductExtension(url) {
    if (!isProduct || !url || url.indexOf('/extensions/') === -1) return false;
    return !isJudgeMeAsset(url) && !isFraudGuardAsset(url);
  }

  function matches(url, patterns) {
    if (!url) return false;
    for (var i = 0; i < patterns.length; i++) {
      if (url.indexOf(patterns[i]) !== -1) return true;
    }
    return false;
  }

  function holdScript(node, bucket) {
    if (node.dataset.snrHeld) return;
    node.dataset.snrHeld = '1';
    node.type = 'text/plain';
    deferredBuckets[bucket].push(node);
    if (bucket === 'restock') {
      if (isProduct) {
        schedulePostPaintActivation();
      } else {
        scheduleRestockActivation();
      }
    }
    if (bucket === 'postPaint') {
      schedulePostPaintActivation();
    }
    if (bucket === 'indexApps') {
      scheduleIndexAppsActivation();
    }
    if (bucket === 'dealeasy' && isProduct) {
      scheduleDealEasyActivation();
    }
  }

  function scheduleDealEasyActivation() {
    if (dealEasyActivateTimer) return;
    dealEasyActivateTimer = window.setTimeout(function () {
      dealEasyActivateTimer = null;
      activateDealEasyAssets();
    }, 0);
  }

  function scheduleRestockActivation() {
    if (restockActivateTimer) return;
    restockActivateTimer = window.setTimeout(function () {
      restockActivateTimer = null;
      activateRestockAssets();
    }, 0);
  }

  function restoreScriptSrc(node) {
    if (!node.src && node.dataset.snrSrc) {
      node.src = node.dataset.snrSrc;
    }
  }

  function blockScript(node) {
    if (node.dataset.snrHeld) return;
    node.dataset.snrHeld = '1';
    if (node.src) {
      node.dataset.snrSrc = node.src;
      node.removeAttribute('src');
    }
    node.type = 'text/plain';
    blockedScripts.push(node);
  }

  function holdStylesheet(node) {
    if (node.dataset.snrHeld) return;
    node.dataset.snrHeld = '1';
    node.media = 'print';
    node.setAttribute('data-snr-media', 'print');
  }

  function blockStylesheet(node) {
    if (node.dataset.snrHeld) return;
    node.dataset.snrHeld = '1';
    node.dataset.snrBlocked = '1';
    if (node.href) {
      node.dataset.snrHref = node.href;
      node.removeAttribute('href');
    }
    node.media = 'not all';
  }

  function isRestockScript(url) {
    return url && url.indexOf('restockrooster') !== -1;
  }

  function isRestockStylesheet(url) {
    return url && url.indexOf('back-in-stock') !== -1;
  }

  function isDealEasyScript(url) {
    return url && url.indexOf('dealeasy') !== -1;
  }

  function isDealEasyWidgetsScript(url) {
    return url && url.indexOf('dealeasy-widgets') !== -1;
  }

  function isAppEmbedScript(url) {
    return url && url.indexOf('app-embed.js') !== -1;
  }

  function isFraudGuardScript(url) {
    return url && url.indexOf('fraud-guard') !== -1;
  }

  function isEssentialAppScript(url) {
    if (isDealEasyScript(url) && pageType === 'cart') return true;
    return false;
  }

  function isJudgeMeAsset(url) {
    if (!url) return false;
    return (
      url.indexOf('judge.me') !== -1 ||
      url.indexOf('judgeme') !== -1 ||
      url.indexOf('judge-me') !== -1
    );
  }

  function isSecurityScript(url) {
    if (!url) return false;
    return (
      url.indexOf('storefront-forms-hcaptcha') !== -1 ||
      url.indexOf('hcaptcha.com') !== -1 ||
      url.indexOf('recaptcha') !== -1
    );
  }

  function isInstagramAsset(url) {
    return url && url.indexOf('mp-instagram') !== -1;
  }

  function isBonLoyaltyAsset(url) {
    if (!url) return false;
    return (
      url.indexOf('bon-loyalty') !== -1 ||
      url.indexOf('bonloyalty.com') !== -1 ||
      url.indexOf('/loyalty_page/') !== -1
    );
  }

  function isHomeDeferAsset(url) {
    return isIndex && (isJudgeMeAsset(url) || isInstagramAsset(url));
  }

  function shouldSkipDefer(url) {
    if (isSecurityScript(url)) return true;
    if (isEssentialAppScript(url)) return true;
    /* Judge.me must load immediately on product — lazy load breaks widgets (logo placeholder). */
    if (isJudgeMeAsset(url) && (isTestimonialsPage || isProduct)) return true;
    /* DealEasy volume table: core script only; widget bundle can wait until after paint. */
    if (isDealEasyScript(url) && isProduct && !isDealEasyWidgetsScript(url)) return true;
    /* Restock notify button must run before variant UI swaps to sold out. */
    if (isRestockScript(url) && isProduct && needsRestock) return true;
    if (isContactPage) return true;
    return false;
  }

  function getScriptBucket(url) {
    if (isBonLoyaltyAsset(url)) return 'block';
    if (isIndex && url) {
      if (isDealEasyScript(url) || url.indexOf('mws_fees') !== -1) return 'block';
    }
    if ((isCollection || isProduct) && url) {
      if (isCollection && isDealEasyScript(url)) return 'block';
      if (isBlockedProductExtension(url)) return 'block';
    }
    if (collectionDrawerMode && isCollectionLazyScript(url)) return 'collectionFacets';
    if (isDealEasyScript(url) && dealEasyLazyProduct) return 'dealeasy';
    if (isRestockScript(url)) {
      return needsRestock ? 'restock' : 'block';
    }
    if (isAppEmbedScript(url) && !isJudgeMeAsset(url)) return isIndex ? 'indexApps' : 'postPaint';
    if (isFraudGuardScript(url)) return isIndex ? 'indexApps' : 'postPaint';
    if (isDealEasyWidgetsScript(url) && isProduct) return 'postPaint';
    if (matches(url, DEFER_SCRIPT)) return 'general';
    return null;
  }

  function inspectNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.dataset.snrLoaded === '1') return;

    if (node.tagName === 'SCRIPT' && (node.src || node.id === 'captcha-provider')) {
      if (node.id === 'captcha-provider' || shouldSkipDefer(node.src)) {
        return;
      }

      var bucket = getScriptBucket(node.src);
      if (bucket === 'block') {
        blockScript(node);
        return;
      }
      if (bucket) {
        holdScript(node, bucket);
      }
    }

    if (node.tagName === 'LINK' && node.rel === 'stylesheet') {
      if ((isTestimonialsPage || isProduct) && isJudgeMeAsset(node.href)) {
        return;
      }
      if (isProduct && needsRestock && isRestockStylesheet(node.href)) {
        return;
      }
      if (
        collectionDrawerMode &&
        node.href &&
        node.href.indexOf('compare.css') !== -1
      ) {
        holdStylesheet(node);
        return;
      }
      if (isBonLoyaltyAsset(node.href)) {
        blockStylesheet(node);
        return;
      }
      if (isHomeDeferAsset(node.href) || matches(node.href, DEFER_STYLE)) {
        holdStylesheet(node);
      }
    }
  }

  function releaseStylesheets() {
    document.querySelectorAll('link[data-snr-held="1"]:not([data-snr-blocked="1"])').forEach(function (link) {
      link.media = 'all';
    });
  }

  function cloneScript(placeholder) {
    restoreScriptSrc(placeholder);
    var script = document.createElement('script');
    script.src = placeholder.src;
    script.async = false;
    if (placeholder.id) script.id = placeholder.id;
    if (placeholder.crossOrigin) script.crossOrigin = placeholder.crossOrigin;
    if (placeholder.referrerPolicy) script.referrerPolicy = placeholder.referrerPolicy;
    if (placeholder.dataset.shopifyFeature) {
      script.dataset.shopifyFeature = placeholder.dataset.shopifyFeature;
    }
    return script;
  }

  function loadScriptsAsync(placeholders) {
    placeholders.forEach(function (placeholder) {
      if (!placeholder.parentNode) return;
      var script = cloneScript(placeholder);
      script.async = true;
      script.dataset.snrLoaded = '1';
      placeholder.parentNode.replaceChild(script, placeholder);
    });
  }

  function takeBucket(name) {
    var scripts = deferredBuckets[name];
    deferredBuckets[name] = [];
    return scripts;
  }

  function activateDealEasyAssets() {
    if (bucketActivated.dealeasy) return;
    var scripts = takeBucket('dealeasy');
    if (!scripts.length) return;
    bucketActivated.dealeasy = true;
    loadScriptsAsync(scripts);
  }

  function releaseRestockStylesheets() {
    document.querySelectorAll('link[data-snr-held="1"]').forEach(function (link) {
      if (link.href && link.href.indexOf('back-in-stock') !== -1) {
        link.media = 'all';
      }
    });
  }

  function activateRestockAssets() {
    if (!needsRestock) return;
    releaseRestockStylesheets();
    var scripts = takeBucket('restock');
    if (!scripts.length) return;
    bucketActivated.restock = true;
    loadScriptsAsync(scripts);
  }

  function activateGeneralAssets() {
    if (bucketActivated.general) return;
    bucketActivated.general = true;
    loadScriptsAsync(takeBucket('general'));
  }

  function activateCollectionFacets() {
    if (!collectionDrawerMode || bucketActivated.collectionFacets) return;
    bucketActivated.collectionFacets = true;
    loadScriptsAsync(takeBucket('collectionFacets'));
  }

  function activateIndexAppAssets() {
    if (bucketActivated.indexApps) return;
    var scripts = takeBucket('indexApps');
    if (!scripts.length) return;
    bucketActivated.indexApps = true;
    loadScriptsAsync(scripts);
  }

  function runIndexAppWork() {
    activateIndexAppAssets();
    activateGeneralAssets();
    releaseStylesheets();
  }

  function scheduleIndexAppsActivation() {
    if (!isIndex || indexAppsScheduled) return;
    indexAppsScheduled = true;
    setupIndexLazyApps();
  }

  var indexAppsScheduled = false;

  function setupIndexLazyApps() {
    if (!isIndex) return;

    function loadIndexApps() {
      if (!activated) {
        activated = true;
        removeActivateListeners();
      }
      runIndexAppWork();
    }

    var hasLazyTarget = observeWhenVisible(
      [
        '.shopify-app-block',
        '[id*="judgeme"]',
        '.jdgm-widget',
        '.section-testimonials',
        '[id*="mp-instagram"]',
        '.instagram-feed-section',
        '.featured-collection',
        '.section--featured-collection'
      ],
      loadIndexApps,
      '350px 0px'
    );

    if (!hasLazyTarget) {
      window.setTimeout(loadIndexApps, 8000);
    }
  }

  function activatePostPaintAssets() {
    if (bucketActivated.postPaint) return;
    var scripts = takeBucket('postPaint');
    if (!scripts.length) return;
    bucketActivated.postPaint = true;
    loadScriptsAsync(scripts);
  }

  function runPostPaintWork() {
    activatePostPaintAssets();
    if (needsRestock) {
      activateRestockAssets();
    }
  }

  function schedulePostPaintActivation() {
    if (postPaintScheduled) return;
    postPaintScheduled = true;

    function run() {
      runPostPaintWork();
      if (!bucketActivated.postPaint && deferredBuckets.postPaint.length) {
        postPaintScheduled = false;
        schedulePostPaintActivation();
      }
    }

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    } else {
      window.setTimeout(run, 0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    }
  }

  function removeActivateListeners() {
    ACTIVATE_EVENTS.forEach(function (ev) {
      window.removeEventListener(ev, activateDeferred, PASSIVE);
    });
  }

  function activateDeferred() {
    if (activated) return;
    activated = true;
    removeActivateListeners();

    if (isIndex) {
      runIndexAppWork();
    } else {
      releaseStylesheets();
      activateGeneralAssets();
    }

    if (needsRestock) {
      activateRestockAssets();
    }
  }

  function observeWhenVisible(selectors, callback, rootMargin) {
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }

    var elements = [];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        elements.push(node);
      });
    });

    if (!elements.length) {
      return false;
    }

    var done = false;
    var observer = new IntersectionObserver(
      function (entries) {
        if (done) return;
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            done = true;
            observer.disconnect();
            callback();
            return;
          }
        }
      },
      { rootMargin: rootMargin || '250px 0px' }
    );

    elements.forEach(function (node) {
      observer.observe(node);
    });
    return true;
  }

  function findDealEasyMount() {
    return document.querySelector(
      '[id*="dealeasy" i], [class*="dealeasy" i], [data-shopify-app*="dealeasy" i], .lb-bundle-widget, [class*="lb-"]'
    );
  }

  function setupProductLazyApps() {
    if (!isProduct) return;

    document.addEventListener('variant:changed', function () {
      var submit = document.querySelector('product-info [name="add"]');
      if (submit && submit.disabled) {
        activateRestockAssets();
      }
    });
  }

  function setupCollectionLazyApps() {
    if (!isCollection || !needsRestock) return;

    observeWhenVisible(
      [
        '.product-card .f-badge--soldout',
        '.product-card [data-sold-out]',
        '.product-card .price--sold-out'
      ],
      activateRestockAssets,
      '200px 0px'
    );
  }

  function setupCollectionLazyFacets() {
    if (!collectionDrawerMode) return;

    var triggerSelector =
      '.collection__toolbar, .facet-drawer-wrapper, .facet-drawer, compare-switch, #ProductCompareSwitch';

    function maybeActivate(event) {
      if (event.target.closest(triggerSelector)) {
        activateCollectionFacets();
      }
    }

    document.addEventListener('pointerdown', maybeActivate, { capture: true, passive: true });
    document.addEventListener('keydown', maybeActivate, { capture: true, passive: true });
  }

  var PASSIVE = { passive: true, once: true };
  var ACTIVATE_EVENTS =
    strictDefer || indexAppDefer
      ? ['scroll', 'pointerdown', 'keydown', 'touchstart']
      : ['scroll', 'pointerdown', 'keydown', 'touchstart'];

  function boot() {
    document.querySelectorAll('script[src]').forEach(inspectNode);
    document.querySelectorAll('link[rel="stylesheet"]').forEach(inspectNode);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(inspectNode);
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    ACTIVATE_EVENTS.forEach(function (ev) {
      window.addEventListener(ev, activateDeferred, PASSIVE);
    });

    if (isContactPage) {
      setTimeout(activateDeferred, 0);
    } else if (isTestimonialsPage) {
      setTimeout(activateDeferred, 500);
    } else if (!interactionOnly && !productDesktopStrict) {
      setTimeout(activateDeferred, 6000);
    }

    setupProductLazyApps();
    setupCollectionLazyApps();
    setupCollectionLazyFacets();

    if (isIndex) {
      scheduleIndexAppsActivation();
    }

    if (isMobile) {
      document.querySelectorAll('.video-hero video-element[autoplay]').forEach(function (node) {
        node.removeAttribute('autoplay');
      });

      if (isProduct) {
        document
          .querySelectorAll(
            '.product__media-item[data-media-type="video"] video-element[autoplay], .product__media-item[data-media-type="external_video"] video-element[autoplay]'
          )
          .forEach(function (node) {
            node.removeAttribute('autoplay');
          });
      }
    }
  }

  boot();
})();
